module.exports = __webpack_public_path__ + "img/message_1.480f0eba.png";